<template>
  <div class="speltfocblem">
    <div class="focblemtit">您关注的同类问题</div>
    <div class="focblemlist">
      <div
        class="focblemitem"
        v-for="(item, index) in list"
        :key="index"
        @click="tojump(item)"
      >
        <div class="wt ellipsis">
          <img src="../../../assets/special/jjwenicon.png" />
          {{ item.title }}
        </div>
        <div class="ify">类型：{{ item.tag }} | {{ item.updated_at }}</div>
      </div>
    </div>
    <div class="seabtn center" @click="jumpjd">立即咨询</div>
  </div>
</template>

<script>
export default {
  props: {
    xh: {
      type: Number,
      default: 5,
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    tojump(item) {
      this.$router.push({
        path: "/laws/articimdet",
        query: {
          articinId: item.id,
        },
      });
    },
    jumpjd() {
      
    },
  },
};
</script>

<style lang="scss" scoped>
.speltfocblem {
  width: 100%;
  padding: 20px;
  .focblemtit {
    font-size: 18px;
    color: #333333;
    padding: 10px 0 20px;
  }
  .focblemlist {
    .focblemitem {
      border-top: 1px solid #eee;
      padding: 18px 0;
      .wt {
        cursor: pointer;
        font-size: 14px;
        color: #333333;
        width: 274px;
        &:hover {
          color: #0465ea;
        }
        img {
          width: 18px;
          height: 18px;
          margin-right: 5px;
        }
      }
      .ify {
        margin-top: 10px;
        font-size: 12px;
        color: #bbbbbb;
      }
    }
  }
  .seabtn {
    width: 250px;
    height: 38px;
    margin: 10px auto 0;
    background: #0465ea;
    border-radius: 3px;
    font-size: 16px;
    color: #ffffff;
  }
}
</style>